import axios from "axios";
import authService from "./authService";
import {jwtDecode} from "jwt-decode";

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {"Content-Type": "application/json"},
});

apiClient.interceptors.request.use(
    (config) => {
        const token = authService.getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const tokenResponse = await authService.refreshToken();
                axios.defaults.headers.common["Authorization"] = `Bearer ${tokenResponse.access_token}`;
                originalRequest.headers["Authorization"] = `Bearer ${tokenResponse.access_token}`;
                return apiClient(originalRequest);
            } catch (refreshError) {
                authService.logout();
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        } else if (error.response && error.response.status === 403) {
            window.location.href = "/access-denied";
        }

        return Promise.reject(error);
    }
);

function isTokenExpired(token : any) {
    if (!token) return true;

    try {
        const decoded = jwtDecode(token);
        if (decoded.exp !== undefined) {
            const currentTime = Date.now() / 1000;
            return decoded.exp < currentTime;
        } else {
            return true;
        }
    } catch (e) {
        return true;
    }
}

export default apiClient;
